/* ============================================================
   VIENTRE DE PAPEL – PACK DE CARTAS (Estándar / Personalizada)
   - Varianti Shopify automatiche (lettura da DOM)
   - Cambio prezzo dinamico
   - Selezione variante corretta
   - Descrizione dinamica
   - Campi dinamici per quantità
   - NO BADGE
   ============================================================ */

document.addEventListener("DOMContentLoaded", function () {

  const wrapper = document.querySelector(".vp-cartas-wrapper");
  if (!wrapper) return;

  const botones = wrapper.querySelectorAll(".vp-boton-tipo");
  const detalles = wrapper.querySelector("#vp-detalles-cartas");
  const descZone = document.querySelector("#vp-descripcion-cartas");
  const priceEl = document.querySelector(".price-item--regular");
  const originalCurrency = priceEl?.dataset.priceCurrency || "EUR";
  
  function parseVariantPrice(value) {
    return parseFloat(String(value || "").trim().replace(",", "."));
  }

  /* ============================================================
     1) Leggiamo le varianti REALI del prodotto dal DOM
     ============================================================ */

  const VP_VARIANTS = {};

  document.querySelectorAll("[data-product-variant]").forEach(el => {
    const option = el.dataset.variantOption?.toLowerCase().trim();
    const id = Number(el.dataset.variantId);
    const price = parseVariantPrice(el.dataset.variantPrice);

    if (!option || !id) return;

    let key = option.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    if (key.includes("personal")) key = "personalizada";
    else key = "estandar";

    VP_VARIANTS[key] = { id, price };
  });

  console.log("=== Varianti Cartas trovate ===", VP_VARIANTS);

  /* ============================================================
     FUNZIONI BASE
     ============================================================ */

  function getQtyInput() {
    return document.querySelector('input[name="quantity"]');
  }

  function cantidad() {
    const input = getQtyInput();
    const v = input ? parseInt(input.value, 10) : 1;
    return isNaN(v) || v < 1 ? 1 : v;
  }

  function tipoActivo() {
    const activo = wrapper.querySelector(".vp-boton-tipo.is-active");
    if (!activo) return "estandar";

    let tipo = activo.dataset.tipo.toLowerCase().trim();
    tipo = tipo.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    return tipo.includes("personal") ? "personalizada" : "estandar";
  }

  function getVariantInput() {
    return document.querySelector('product-form form input[name="id"]');
  }

  /* ============================================================
     CAMBIO VARIANTE + PREZZO
     ============================================================ */

  function updateVariantAndPrice() {
    const idInput = getVariantInput();
    const tipo = tipoActivo();
    const varData = VP_VARIANTS[tipo];

    if (!varData || !idInput) return;

    idInput.value = varData.id;

    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /* ============================================================
     DESCRIZIONE DINAMICA
     ============================================================ */

  function renderDescripcion() {
    if (!descZone) return;

    const tipo = tipoActivo();

    let html = `
      <div class="vp-descripcion">
        <p>Pack de 5 cartas y sobres con un precioso diseño, cada una con un propósito único para tejer una red de apoyo escrito con tu propia letra:</p>
        <ul>
          <li>Una carta para ti misma</li>
          <li>Una carta para tu bebé o tus bebés</li>
          <li>Una carta para tu pareja</li>
          <li>Una carta de tu pareja para ti</li>
          <li>Una carta de alguien que te admire</li>
        </ul>
        <p>Estas cartas serán un salvavidas para los días más duros del posparto y te recordarán que eres una madre increíble.</p>
      </div>
    `;

    if (tipo === "personalizada") {
      html += `
        <div class="vp-descripcion-extra">
          <p><strong>Además, puedes personalizar este pack añadiendo los nombres de la mamá, de la pareja y del bebé o bebés. Es el detalle que más ilusión hace a quienes lo reciben.</strong></p>
        </div>
      `;
    }

    descZone.innerHTML = html;
  }

  /* ============================================================
     RENDER CAMPOS DINAMICI
     ============================================================ */

  function render() {
    const tipo = tipoActivo();
    const cant = cantidad();
    let html = "";

    const saved = {};
    detalles.querySelectorAll("select, input").forEach(el => saved[el.name] = el.value);

    for (let i = 1; i <= cant; i++) {
      html += `
        <div class="vp-pack-bloque">
          <h4 class="vp-pack-titulo">Pack de Cartas ${i}</h4>
      `;

      if (tipo === "estandar") {
        html += `
          <label>¿Esperas uno o más bebés?</label>
          <select name="properties[Pack ${i} - Bebés]"
                  class="vp-select hijos-select"
                  data-pack="${i}">
            <option value="1 bebé">1 bebé</option>
          <option value="Más de 1 bebé">Más de 1 bebé</option>
          </select>
        `;
      }

      if (tipo === "personalizada") {
        html += `
          <label>Nombre de la mamá</label>
          <input type="text" name="properties[Pack ${i} - Mamá]" class="vp-input"><br>

          <label>Nombre de la pareja</label>
          <input type="text" name="properties[Pack ${i} - Pareja]" class="vp-input"><br>

          <label>¿Esperas uno o más bebés?</label>
          <select name="properties[Pack ${i} - Bebés]"
                  class="vp-select hijos-select"
                  data-pack="${i}">
            <option value="1 bebé">1 bebé</option>
            <option value="Más de 1 bebé">Más de 1 bebé</option>
          </select>

          <div class="vp-hijos-zone" data-pack-hijos="${i}"></div>
        `;
      }

      html += `</div>`;
    }

    html += `<input type="hidden" name="attributes[_tipo_pack]" value="${tipo}">`;

    detalles.innerHTML = html;

    detalles.querySelectorAll("select, input").forEach(el => {
      if (saved[el.name]) el.value = saved[el.name];
    });

    detalles.querySelectorAll(".hijos-select").forEach(sel => {
      sel.addEventListener("change", updateHijos);
      updateHijos({ target: sel });
    });

    updateVariantAndPrice();
    renderDescripcion();
  }

  /* ============================================================
     FIGLI DINAMICI
     ============================================================ */

  function updateHijos(e) {
    const select = e.target;
    const pack = select.dataset.pack;
    const zone = detalles.querySelector(`[data-pack-hijos="${pack}"]`);
    if (!zone) return;

    if (select.value === "1 bebé") {
      zone.innerHTML = `
        <label>Nombre del bebé</label>
        <input type="text" name="properties[Pack ${pack} - Bebé 1]" class="vp-input">
      `;
    } else {
      zone.innerHTML = `
        <label>Nombre del bebé 1</label>
        <input type="text" name="properties[Pack ${pack} - Bebé 1]" class="vp-input"><br>
        <label>Nombre del bebé 2</label>
        <input type="text" name="properties[Pack ${pack} - Bebé 2]" class="vp-input">
      `;
    }
  }

  /* ============================================================
     EVENTI
     ============================================================ */

  botones.forEach(btn => {
    btn.addEventListener("click", () => {
      botones.forEach(b => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      render();
    });
  });

  document.body.addEventListener("input", e => {
    if (e.target.matches('input[name="quantity"]')) render();
  });

  document.body.addEventListener("click", e => {
    if (e.target.closest(".quantity__button")) setTimeout(render, 50);
  });

  /* INIT */
  render();
  updateVariantAndPrice();
});
